import React from "react";
import PropTypes from "prop-types";
import { useFormik } from "formik";
import TextInput from "../TextInput";
import PasswordStrength from "../../PasswordStrength";
import Button from "../../Button";
import i18next from "i18next";
import {
    mustMatch,
    isRequired,
    isPasswordStrong,
} from "../../../Helpers/validators";

const validate = (values) => {
    const errors = {};

    if (isRequired(values.newPassword)) {
        errors.newPassword = "form.errors.required";
    } else if (isPasswordStrong(values.newPassword)) {
        errors.newPassword = "form.errors.notStrong";
    }

    if (isRequired(values.repeatPassword)) {
        errors.repeatPassword = "form.errors.required";
    } else if (mustMatch(values.repeatPassword, values.newPassword)) {
        errors.repeatPassword = "form.errors.mustMatch.password";
    }

    return errors;
};

const EditPasswordForm = ({ onSubmit, isLoading }) => {
    const formik = useFormik({
        initialValues: {
            newPassword: "",
            repeatPassword: "",
        },
        onSubmit: async (values) => {
            onSubmit(values, formik.dirty);
        },
        validate,
    });

    return (
        <form id="edit-password-form" onSubmit={formik.handleSubmit}>
            <TextInput
                bindName="newPassword"
                value={formik.values.newPassword}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label={i18next.t("form.label.newPassword")}
                error={
                    formik.touched.newPassword && !!formik.errors.newPassword
                }
                errorMessage={i18next.t(formik.errors.newPassword)}
                type="password"
            />
            <TextInput
                bindName="repeatPassword"
                value={formik.values.repeatPassword}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label={i18next.t("form.label.repeatPassword")}
                error={
                    formik.touched.repeatPassword &&
                    !!formik.errors.repeatPassword
                }
                errorMessage={i18next.t(formik.errors.repeatPassword)}
                type="password"
            />
            <PasswordStrength password={formik.values.newPassword} />
            <Button
                type="submit"
                loading={isLoading}
                label={i18next.t("form.label.changePassword")}
            />
        </form>
    );
};

EditPasswordForm.propTypes = {
    onSubmit: PropTypes.func,
    isLoading: PropTypes.bool,
};

export default EditPasswordForm;
